import { getNewTeamList } from '@/api/api_team'

const state = {
  dshTeamData: []
}

const mutations = {
  SET_DSH_PROBLEM_DATA: (state, data) => {
    state.dshTeamData = data
  }
}

const actions = {
  actions_getNewTeamList ({commit}) {
    return new Promise((resolve, reject) => {
      getNewTeamList().then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_DSH_PROBLEM_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  dshTeamList: state => state.dshTeamData
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/teamListData.js